import { createAction, props } from '@ngrx/store';
import { DefinitionsTO } from './definitions.interface';

export const definitionsLoadAction = createAction('definitions:LOAD');
export const definitionsLoadSuccessAction = createAction('definitions:LOAD_SUCCESS', props<{ definitions: DefinitionsTO; language: string }>());
export const definitionsLoadFailAction = createAction('definitions:LOAD_FAIL', props<{statusText: string, status: number, message: string}>());

// TODO find better way
// @ts-ignore
definitionsLoadAction.logPayload = true
// @ts-ignore
definitionsLoadFailAction.logPayload = true
